<div class="h-100">
    <div class="font-size-16 border-bottom pt-3 mx-3 mb-3" style="padding-bottom:12px" cvLocalizedText langSection="Assign_Tool" langKey="Assigned_To">Assigned to:</div>

    <div class="px-3 pb-3" style="height:calc(100% - 69px); overflow-y:scroll">
        <div class="font-size-16 lato-bold mb-3" cvLocalizedText langSection="Assign_Tool" langKey="Employee_Groups">Employee Group(s)</div>
        <div *ngIf="lst.length == 0" cvLocalizedText langSection="Assign_Tool" langKey="All_Emp_Groups">All Emp Groups</div>

        <div *ngFor="let groupType of empgrouptypes" [hidden]="filteredList(groupType.GroupLevel).length <= 0">
            <div class="lato-bold">{{groupType.GroupTypeName}}</div>
            <div class="assignItem hoverContainer d-flex justify-content-between align-items-center" style="height:28px" *ngFor="let entry of filteredList(groupType.GroupLevel)">
                <span class="ml-1">- {{entry.GroupName}}</span>
                <button type="button" class="icon-btn displayHoverFlex d-none" (click)="onremove(entry)"><img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg"></button>
            </div>
        </div>
    </div>
</div>
